import { takeEvery } from 'redux-saga/effects';
import openSocket from 'socket.io-client';

import store from '../index';

import { fetchConfig } from '../slices/templatesConfig';
import { fetchSources } from '../slices/dataSources';
import * as actionTypes from '../constants';

let socket = null;

const executeWithDelay = (fn) => {
  setTimeout(fn, Math.floor(Math.random() * 3000));
};

export const connectWebsocket = () => {
  if (socket !== null) {
    return;
  }

  const state = store.getState();
  const { authentication } = state;

  //console.log("player ws to ", import.meta.env.CFW, window.config.playerWsUrl + window.config.playerWsPath);

  const query = {
    protocol: 'sio1',
  };

  if (window.config && window.config.clientId) {
    query['tenantId'] = window.config.clientId;
  }

  const options = {
    path: '/ws',
    forceNew: true,
    transports: ['websocket'],
    allowEIO3: true,
    query,
  };

  if (window.config.guestToken) {
    options.query.auth = 'Bearer ' + window.config.guestToken;
    options.auth = {
      token: 'Bearer ' + window.config.guestToken,
    };
  }

  socket = openSocket(window.config.playerWsUrl, options);

  socket.on('templatization_config_change', (data) => {
    try {
      if (data && data.length && Array.isArray(data)) {
        const tenantId = window.config.clientId;
        const siteId = window.config.siteId;

        const exists = data.find((item) => {
          if (typeof item === 'object') {
            return (
              item?.tenantId?.toString?.() === tenantId?.toString?.() &&
              item?.siteId?.toString?.() === siteId?.toString?.()
            );
          } else if (typeof item === 'string') {
            return item?.toString?.() === siteId?.toString?.();
          }
          return false;
        });
        if (exists) {
          if (import.meta.env.DEV) {
            // for dev execute immediately
            store.dispatch(fetchConfig({ tenantId: tenantId, siteId: siteId, bucketPath: exists?.bucketPath }));
          } else {
            executeWithDelay(() => {
              store.dispatch(
                fetchConfig({ tenantId: tenantId, siteId: window.config.siteId, bucketPath: exists?.bucketPath }),
              );
            });
          }
        }
      }
    } catch (e) {
      /**/
    }
  });

  socket.on('data_source_change', (data) => {
    if (data && data.length && Array.isArray(data)) {
      const state = store.getState().dataSources.items;

      let fetchIds = [];

      // re-fetch only the data sources that are already in the state; the rest will get fetched on demand
      data.forEach((id) => {
        if (id === window.config.dataSourceAllJackpots) return;
        if (state[id] != null) {
          fetchIds.push(id);
        }
      });

      if (fetchIds.length) {
        executeWithDelay(() => {
          store.dispatch(fetchSources({ ids: fetchIds }));
        });
      }
    }
  });
};

export function* websocketSaga(action) {
  if (socket === null) {
    connectWebsocket();
    return;
  }

  if (['user', 'token'].indexOf(action.authType) > -1) {
    yield socket.emit('login', {
      token: 'Bearer ' + window.config.guestToken,
    });
  }
}

export function* watchTemplatizationWebsocket() {
  yield takeEvery(actionTypes.application.INITIALIZE, websocketSaga);
}
